
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 4.2h-5l-.08-2.25A1.84 1.84 0 0015.24 0H8.76a1.83 1.83 0 00-1.69 1.93L7 4.2H2a.5.5 0 000 1h1.9l1.09 16.54A2.26 2.26 0 007.23 24h9.54A2.25 2.25 0 0019 21.76l1.1-16.57H22a.5.5 0 000-1zM8.07 1.94c0-.51.32-.95.7-.95h6.47c.37 0 .69.44.69.97L16 4.19H8zm9.94 19.78A1.26 1.26 0 0116.76 23H7.24a1.27 1.27 0 01-1.25-1.3L4.9 5.2h14.2z"}}),_c('path',{attrs:{"d":"M8.09 8.08a.5.5 0 00-.47.53l.68 11.62a.5.5 0 00.5.47h.03a.5.5 0 00.47-.53L8.61 8.55a.5.5 0 00-.52-.47zm3.33 3.88a.5.5 0 00-.47.52l.38 7.74a.5.5 0 00.5.48h.02a.5.5 0 00.48-.53l-.39-7.74a.5.5 0 00-.52-.47z"}})])
          )
        }
      }
    